import React from "react";

export default function ContactFooterBottomBar({ copyright, address, links }) {
  return (
    <div className="grid grid-cols-1 items-center gap-4 border-t border-[rgba(255,255,255,0.06)] pt-[1.15rem] md:grid-cols-[minmax(0,1fr)_auto_auto]">
      <p className="m-0 text-[0.78rem] leading-[1.55] text-[rgba(193,201,214,0.55)]">{copyright}</p>
      <p className="m-0 text-[0.78rem] leading-[1.55] text-[rgba(193,201,214,0.55)]">{address}</p>
      <nav aria-label="Rechtliches" className="flex flex-wrap gap-[1.1rem] md:justify-end">
        {links.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="text-[0.78rem] text-[rgba(220,225,236,0.58)] no-underline transition hover:text-white"
          >
            {link.label}
          </a>
        ))}
      </nav>
    </div>
  );
}
